import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import { FaUpload, FaTrash, FaCheck } from "react-icons/fa";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import { Input } from "./input";
import { getSchemesDropdown, uploadExcelFile } from "../../utils/util";
import { useDispatch } from "react-redux";
import { loaderSet } from "../../context/actions/loaderAction";
import { alertDanger, alertSuccess } from "../../context/actions/toastAction";
import Loader from "../loader";
import { Dialog, DialogContent, DialogDescription, DialogOverlay, DialogTitle } from '@radix-ui/react-dialog'
import { Button } from "./button";
import { setAllSchemeDetails } from "../../context/actions/allSchemeDetailsAction";
const FileUpload = ({forWhichUserType="admin"}) => {
  const [file, setFile] = useState(null);
const dispatch =useDispatch()
const [isLoading,setIsLoading]=useState(false)
const [missingSchemeDetailsMessage,setMissingDetailsMessage]=useState('')
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "application/vnd.ms-excel": [".xls"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx",
      ],
    },
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        setFile(acceptedFiles[0]);
      }
    },
    multiple: false, // Only accept one file at a time
    onDropRejected: (rejectedFiles) => {
      rejectedFiles.forEach((file) => {
        toast.error(
          `File ${file.name} is not a valid type. Accepted types: .xls, .xlsx.`
        );
      });
    },
  });


    const [isOpenUploadSchemeExcelErrors,setIsOpenUploadSchemeExcelErrors]=useState(false)
  
    const handleIsCloseUploadSchemeExcelErrors=()=>{
    
      // setSelectedClassOptions([])
      setIsOpenUploadSchemeExcelErrors(false)
    }



    const getAllSchemeDetails=async()=>{
        try {
          const response =await getSchemesDropdown()
          console.log("response for gett all schemes dropdown from admin index.js file ",response.data)
          if(response){
            dispatch(setAllSchemeDetails(response?.data));
          }
        } catch (error) {
          console.log("Error in get all schemes dropdown ",error)
        }
      }

  const handleConfirm = async () => {
    console.log("file",file)
    // dispatch(loaderSet(true))
    setIsLoading(true)
    if (file) {
      const formData = new FormData();
      formData.append("file", file); // Append the file to FormData
      console.log("fotmdata",formData)
      try {
        // Send the file to the backend
       const response =await uploadExcelFile(formData)

        // Handle success
        if(response){
          console.log("hii file uploaded",response.data);
          setFile(null); // Clear the file after upload
          if(response.code===200){
          dispatch(alertSuccess("File uploaded successfully"))
          if(forWhichUserType==="admin")
          {
             getAllSchemeDetails()
          }
         
          // dispatch(loaderSet(false))
          //  dispatch(loaderSet(false))
          setIsLoading(false)
        return
      }
    
      if(response.code===500){
        dispatch(alertDanger("Error in File Uploading"))
        // dispatch(loaderSet(false))
        //  dispatch(loaderSet(false))
        setIsLoading(false)
      return
    }
    if(response.code===400){
      setIsOpenUploadSchemeExcelErrors(!isOpenUploadSchemeExcelErrors)
      setMissingDetailsMessage(response?.data)
      // dispatch(alertDanger(response.data[0].message))
      // dispatch(loaderSet(false))
      //  dispatch(loaderSet(false))
      setIsLoading(false)
    return
  }
  if(response.code===404){
    dispatch(alertDanger(response.data[0].message))
    // dispatch(loaderSet(false))
    //  dispatch(loaderSet(false))
    setIsLoading(false)
  return
}
       else{
          // dispatch(loaderSet(false))
          // throw new Error("Failed to upload file")
          dispatch(alertDanger(response.data[0].message))
          setIsLoading(false)
          return
          // throw new Error(response.data[0].message)
          
        }
        
        }
        
        
        // toast.success("File uploaded and processed successfully!");
      } catch (error) {
        console.error("Error uploading file:", error);
        dispatch(alertDanger(error.message))
       setIsLoading(false)
        // toast.error("Failed to upload file. Please try again.");
      }
      finally{
        
        
          // setTimeout(() => dispatch(loaderSet(false)), 3000); // Adds a slight delay
        
      }
    } else {
      toast.error("No file selected.");
    }
  };

  const handleDelete = () => {
    setFile(null);
  };

  return (
    
    <>
      <div className="flex flex-col items-center space-y-4">
      {
        isLoading && <Loader/>
      }
      <Toaster position="top-right" reverseOrder={false} />
      <div
        {...getRootProps({
          className:
            "border-2 border-dashed border-[#3a5dd1] rounded-lg p-6 text-center cursor-pointer hover:bg-blue-100 transition-colors w-full",
        })}
      >
        <Input {...getInputProps()} />
        <div className="flex flex-col items-center justify-center">
          <FaUpload size={48} className="text-[#0D215C]" />
          <p className="mt-4 text-lg text-gray-700">
            Add Excel file here (.xls, .xlsx)
          </p>
        </div>
      </div>

      {file && (
        <div className="w-full space-y-2">
          <div className="flex items-center justify-between p-4 bg-gray-100 rounded-lg shadow">
            <span className="text-gray-800">{file.name}</span>
            <div className="flex space-x-2">
              <button
                className="text-green-600 hover:text-green-800"
                onClick={handleConfirm}
              >
                <FaCheck />
              </button>
              <button
                className="text-red-600 hover:text-red-800"
                onClick={handleDelete}
              >
                <FaTrash />
              </button>
            </div>
          </div>
        </div>
      )}





    </div>
    <Dialog open={isOpenUploadSchemeExcelErrors} onOpenChange={handleIsCloseUploadSchemeExcelErrors}>
  {/* Overlay */}
  <DialogOverlay className="fixed inset-0 bg-black bg-opacity-20 z-40 " />

  {/* Dialog Content */}
  <DialogContent className="fixed inset-0 m-auto  bg-white z-50 p-6 rounded-none max-h-96  overflow-y-scroll shadow-lg max-w-lg w-full flex flex-col">
    <div>
      <DialogTitle className="text-lg font-bold">Upload Scheme Excel</DialogTitle>
      <DialogDescription className="mt-4">
      <p className="mt-2 text-red-600 font-semibold ">
  The following missing scheme details were found in the uploaded Excel sheet:
</p>
        <div className="mt-4 space-y-6">
          {/* Iterate over each sheet and display errors */}
          {missingSchemeDetailsMessage?.length > 0 &&
            missingSchemeDetailsMessage.map((sheetData, index) => (
              <div key={index} className="bg-gray-50 p-4 rounded-md shadow-sm">
                <h3 className="font-semibold text-indigo-700">{sheetData.sheet}</h3>
                <ul className="mt-2 space-y-2">
                  {sheetData.errors.map((error, idx) => (
                    <li key={idx} className="text-sm text-gray-800">
                      <span className="font-bold">{error.schemeName}</span>
                      {sheetData.sheet === "Overview" || sheetData.sheet === "Fund Performance" || sheetData.sheet==="Fund" ?  (
                        <span className="text-gray-600 font-semibold"> (Class: {error.schemeClass || "NA"})</span>
                      ) : null}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
        </div>
      </DialogDescription>
    </div>
    <div className="mt-6 flex justify-end gap-4">
      <Button
        type="button"
        onClick={() => handleIsCloseUploadSchemeExcelErrors()}
        className="bg-red-700 text-white"
      >
        Okay
      </Button>
    </div>
  </DialogContent>

  {/* Custom Scroll Styling */}
  <style jsx>{`
    .overflow-y-scroll::-webkit-scrollbar {
      width: 8px;
    }
    .overflow-y-scroll::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 4px;
    }
    .overflow-y-scroll::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
    .overflow-y-scroll::-webkit-scrollbar-track {
      background: #f0f0f0;
    }
  `}</style>
</Dialog>
    </>
  
  );
};

export default FileUpload;
